import React, {} from "react";
import { ExclamationCircleFilled, IdcardOutlined, SwapOutlined } from "@ant-design/icons";
import { Row, Tag } from "antd";
import { TrailerTypeMap, TrailerType } from "@/utils/enum";
import TWIC from "@/components/Tags/TWIC";
export const getShipmentTagsList = (shipmentData) => {
    const tags = [];
    const { childShipmentId, parentShipmentId, requiresEModal, requiresTWIC, requiresLotExit, trailerType, isExchangeRequired, } = shipmentData;
    tags.push(React.createElement(Tag, { key: 1, color: trailerType === TrailerType.Enclosed ? "purple" : "blue", style: { marginLeft: 5, fontWeight: "bold" } }, TrailerTypeMap[trailerType]));
    if (requiresEModal) {
        tags.push(React.createElement(Tag, { key: 0, color: "purple", style: { marginLeft: 5, fontWeight: "bold" }, icon: React.createElement(IdcardOutlined, null) }, "EMODAL"));
    }
    if (requiresTWIC) {
        tags.push(React.createElement(TWIC, { key: 1 }));
    }
    if (requiresLotExit) {
        tags.push(React.createElement(Tag, { key: 2, color: "orange", style: { marginLeft: 5, fontWeight: "bold" }, icon: React.createElement(ExclamationCircleFilled, null) }, "Lot Exit"));
    }
    if (childShipmentId || parentShipmentId) {
        const text = isExchangeRequired ? "Dealer Exchange (required)" : "Dealer Exchange";
        const color = isExchangeRequired ? "warning" : "processing";
        tags.push(React.createElement(Tag, { key: 3, color: color, style: { marginLeft: 5, fontWeight: "bold" }, icon: React.createElement(SwapOutlined, null) }, text));
    }
    return tags;
};
const ShipmentTagsList = ({ shipmentData }) => (React.createElement(Row, { justify: "end" }, getShipmentTagsList(shipmentData)));
export default ShipmentTagsList;
